import {
  useStyle 
} from "@/classify"
import {
  useSuggestedProduct 
} from "@/hooks/SearchBar"
import Link from "next/link"
import defaultClasses from "./suggestedProduct.module.css"

const SuggestedProduct = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const {
    url_key,
    small_image,
    name,
    onNavigate,
    price,
    price_range,
    url_suffix,
    sku,
  } = props

  const talonProps = useSuggestedProduct({
    name,
    price,
    price_range,
    onNavigate,
    url_key,
    url_suffix,
    sku,
  })

  const {
    handleClick, uri 
  } = talonProps

  return (
    <Link className={classes.root} href={uri} onClick={handleClick}>
      <span className={classes.name}>{name}</span>
    </Link>
  )
}

export default SuggestedProduct
